import { Flag } from '../shared/components/flag';

const countryCodesMapping: { [key: string]: string } = {
    '201': 'AL',
    '202': 'AD',
    '203': 'AT',
    '204': 'PT',
    '205': 'BE',
    '206': 'BY',
    '207': 'BG',
    '208': 'VA',
    '209': 'CY',
    '210': 'CY',
    '211': 'DE',
    '212': 'CY',
    '213': 'GE',
    '214': 'MD',
    '215': 'MT',
    '216': 'AM',
    '218': 'DE',
    '219': 'DK',
    '220': 'DK',
    '224': 'ES',
    '225': 'ES',
    '226': 'FR',
    '227': 'FR',
    '228': 'FR',
    '229': 'MT',
    '230': 'FI',
    '231': 'FO',
    '232': 'GB',
    '233': 'GB',
    '234': 'GB',
    '235': 'GB',
    '236': 'GI',
    '237': 'GR',
    '238': 'HR',
    '239': 'GR',
    '240': 'GR',
    '241': 'GR',
    '242': 'MA',
    '243': 'HU',
    '244': 'NL',
    '245': 'NL',
    '246': 'NL',
    '247': 'IT',
    '248': 'MT',
    '249': 'MT',
    '250': 'IE',
    '251': 'IS',
    '252': 'LI',
    '253': 'LU',
    '254': 'MC',
    '255': 'PT',
    '256': 'MT',
    '257': 'NO',
    '258': 'NO',
    '259': 'NO',
    '261': 'PL',
    '262': 'ME',
    '263': 'PT',
    '264': 'RO',
    '265': 'SE',
    '266': 'SE',
    '267': 'SK',
    '268': 'SM',
    '269': 'CH',
    '270': 'CZ',
    '271': 'TR',
    '272': 'UA',
    '273': 'RU',
    '274': 'MK',
    '275': 'LV',
    '276': 'EE',
    '277': 'LT',
    '278': 'SI',
    '279': 'RS',
    '301': 'AI',
    '303': 'US',
    '304': 'AG',
    '305': 'AG',
    '306': 'CW',
    '307': 'AW',
    '308': 'BS',
    '309': 'BS',
    '310': 'BM',
    '311': 'BS',
    '312': 'BZ',
    '314': 'BB',
    '316': 'CA',
    '319': 'KY',
    '321': 'CR',
    '323': 'CU',
    '325': 'DM',
    '327': 'DO',
    '329': 'GP',
    '330': 'GD',
    '331': 'GL',
    '332': 'GT',
    '335': 'HN',
    '336': 'HT',
    '338': 'US',
    '339': 'JM',
    '341': 'KN',
    '343': 'LC',
    '345': 'MX',
    '347': 'MQ',
    '348': 'MS',
    '350': 'NI',
    '351': 'PA',
    '352': 'PA',
    '353': 'PA',
    '354': 'PA',
    '355': 'PA',
    '356': 'PA',
    '357': 'PA',
    '358': 'PR',
    '359': 'SV',
    '361': 'PM',
    '362': 'TT',
    '364': 'TC',
    '366': 'US',
    '367': 'US',
    '368': 'US',
    '369': 'US',
    '370': 'PA',
    '371': 'PA',
    '372': 'PA',
    '373': 'PA',
    '374': 'PA',
    '375': 'VC',
    '376': 'VC',
    '377': 'VC',
    '378': 'VG',
    '379': 'VI',
    '401': 'AF',
    '403': 'SA',
    '405': 'BD',
    '408': 'BH',
    '410': 'BT',
    '412': 'CN',
    '413': 'CN',
    '414': 'CN',
    '416': 'TW',
    '417': 'LK',
    '419': 'IN',
    '422': 'IR',
    '423': 'AZ',
    '425': 'IQ',
    '428': 'IL',
    '431': 'JP',
    '432': 'JP',
    '434': 'TM',
    '436': 'KZ',
    '437': 'UZ',
    '438': 'JO',
    '440': 'KR',
    '441': 'KR',
    '443': 'PS',
    '445': 'KP',
    '447': 'KW',
    '450': 'LB',
    '451': 'KG',
    '453': 'MO',
    '455': 'MV',
    '457': 'MN',
    '459': 'NP',
    '461': 'OM',
    '463': 'PK',
    '466': 'QA',
    '468': 'SY',
    '470': 'AE',
    '472': 'TJ',
    '473': 'YE',
    '475': 'YE',
    '477': 'HK',
    '478': 'BA',
    '501': 'FR',
    '503': 'AU',
    '506': 'MM',
    '508': 'BN',
    '510': 'FM',
    '511': 'PW',
    '512': 'NZ',
    '514': 'KH',
    '515': 'KH',
    '516': 'CX',
    '518': 'CK',
    '520': 'FJ',
    '523': 'CC',
    '525': 'ID',
    '529': 'KI',
    '531': 'LA',
    '533': 'MY',
    '536': 'MP',
    '538': 'MH',
    '540': 'NC',
    '542': 'NU',
    '544': 'NR',
    '546': 'PF',
    '548': 'PH',
    '553': 'PG',
    '555': 'PN',
    '557': 'SB',
    '559': 'AS',
    '561': 'WS',
    '563': 'SG',
    '564': 'SG',
    '565': 'SG',
    '566': 'SG',
    '567': 'TH',
    '570': 'TO',
    '572': 'TV',
    '574': 'VN',
    '576': 'VU',
    '577': 'VU',
    '578': 'WF',
    '601': 'ZA',
    '603': 'AO',
    '605': 'DZ',
    '607': 'FR',
    '608': 'GB',
    '609': 'BI',
    '610': 'BJ',
    '611': 'BW',
    '612': 'CF',
    '613': 'CM',
    '615': 'CG',
    '616': 'KM',
    '617': 'CV',
    '618': 'FR',
    '619': 'CI',
    '620': 'KM',
    '621': 'DJ',
    '622': 'EG',
    '624': 'ET',
    '625': 'ER',
    '626': 'GA',
    '627': 'GH',
    '629': 'GM',
    '630': 'GW',
    '631': 'GQ',
    '632': 'GN',
    '633': 'BF',
    '634': 'KE',
    '635': 'FR',
    '636': 'LR',
    '637': 'LR',
    '638': 'SS',
    '642': 'LY',
    '644': 'LS',
    '645': 'MU',
    '647': 'MG',
    '649': 'ML',
    '650': 'MZ',
    '654': 'MR',
    '655': 'MW',
    '656': 'NE',
    '657': 'NG',
    '659': 'NA',
    '660': 'RE',
    '661': 'RW',
    '662': 'SD',
    '663': 'SN',
    '664': 'SC',
    '665': 'SH',
    '666': 'SO',
    '667': 'SL',
    '668': 'ST',
    '669': 'SZ',
    '670': 'TD',
    '671': 'TG',
    '672': 'TN',
    '674': 'TZ',
    '675': 'UG',
    '676': 'CD',
    '677': 'TZ',
    '678': 'ZM',
    '679': 'ZW',
    '701': 'AR',
    '710': 'BR',
    '720': 'BO',
    '725': 'CL',
    '730': 'CO',
    '735': 'EC',
    '740': 'FK',
    '745': 'GF',
    '750': 'GY',
    '755': 'PY',
    '760': 'PE',
    '765': 'SR',
    '770': 'UY',
    '775': 'VE',
};
const countryCodeToFullName: { [key: string]: string } = {
    AL: 'Albania',
    AD: 'Andorra',
    AT: 'Austria',
    PT: 'Portugal',
    BE: 'Belgium',
    BY: 'Belarus',
    BG: 'Bulgaria',
    VA: 'Vatican City',
    CY: 'Cyprus',
    DE: 'Germany',
    GE: 'Georgia',
    MD: 'Moldova',
    MT: 'Malta',
    AM: 'Armenia',
    DK: 'Denmark',
    ES: 'Spain',
    FR: 'France',
    FI: 'Finland',
    FO: 'Faroe Islands',
    GB: 'United Kingdom',
    GI: 'Gibraltar',
    GR: 'Greece',
    HR: 'Croatia',
    MA: 'Morocco',
    HU: 'Hungary',
    NL: 'Netherlands',
    IT: 'Italy',
    IE: 'Ireland',
    IS: 'Iceland',
    LI: 'Liechtenstein',
    LU: 'Luxembourg',
    MC: 'Monaco',
    ME: 'Montenegro',
    RO: 'Romania',
    SE: 'Sweden',
    SK: 'Slovakia',
    SM: 'San Marino',
    NO: 'Norway',
    CH: 'Switzerland',
    CZ: 'Czechia',
    TR: 'Turkey',
    UA: 'Ukraine',
    RU: 'Russia',
    MK: 'North Macedonia',
    LV: 'Latvia',
    EE: 'Estonia',
    LT: 'Lithuania',
    SI: 'Slovenia',
    RS: 'Serbia',
    AI: 'Anguilla',
    US: 'United States',
    AG: 'Antigua and Barbuda',
    CW: 'Curaçao',
    AW: 'Aruba',
    BS: 'Bahamas',
    BM: 'Bermuda',
    BZ: 'Belize',
    BB: 'Barbados',
    CA: 'Canada',
    KY: 'Cayman Islands',
    CR: 'Costa Rica',
    CU: 'Cuba',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    GP: 'Guadeloupe',
    GD: 'Grenada',
    GL: 'Greenland',
    GT: 'Guatemala',
    HN: 'Honduras',
    HT: 'Haiti',
    JM: 'Jamaica',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MX: 'Mexico',
    MQ: 'Martinique',
    MS: 'Montserrat',
    NI: 'Nicaragua',
    PA: 'Panama',
    PR: 'Puerto Rico',
    SV: 'El Salvador',
    PM: 'Saint Pierre and Miquelon',
    TT: 'Trinidad and Tobago',
    TC: 'Turks and Caicos Islands',
    VC: 'Saint Vincent and the Grenadines',
    VG: 'Virgin Islands (British)',
    VI: 'Virgin Islands (U.S.)',
    AF: 'Afghanistan',
    SA: 'Saudi Arabia',
    BD: 'Bangladesh',
    BH: 'Bahrain',
    BT: 'Bhutan',
    CN: 'China',
    TW: 'Taiwan',
    LK: 'Sri Lanka',
    IN: 'India',
    IR: 'Iran',
    AZ: 'Azerbaijan',
    IQ: 'Iraq',
    IL: 'Israel',
    JP: 'Japan',
    TM: 'Turkmenistan',
    KZ: 'Kazakhstan',
    UZ: 'Uzbekistan',
    JO: 'Jordan',
    KR: 'Korea',
    PS: 'Palestine, State of',
    KP: 'Korea',
    KW: 'Kuwait',
    LB: 'Lebanon',
    KG: 'Kyrgyzstan',
    MO: 'Macao',
    MV: 'Maldives',
    MN: 'Mongolia',
    NP: 'Nepal',
    OM: 'Oman',
    PK: 'Pakistan',
    QA: 'Qatar',
    SY: 'Syrian Arab Republic',
    AE: 'United Arab Emirates',
    TJ: 'Tajikistan',
    YE: 'Yemen',
    HK: 'Hong Kong',
    BA: 'Bosnia and Herzegovina',
    AU: 'Australia',
    MM: 'Myanmar',
    BN: 'Brunei Darussalam',
    FM: 'Micronesia',
    PW: 'Palau',
    NZ: 'New Zealand',
    KH: 'Cambodia',
    CX: 'Christmas Island',
    CK: 'Cook Islands',
    FJ: 'Fiji',
    CC: 'Cocos (Keeling) Islands',
    ID: 'Indonesia',
    KI: 'Kiribati',
    LA: "Lao People's Democratic Republic",
    MY: 'Malaysia',
    MP: 'Northern Mariana Islands',
    MH: 'Marshall Islands',
    NC: 'New Caledonia',
    NU: 'Niue',
    NR: 'Nauru',
    PF: 'French Polynesia',
    PH: 'Philippines',
    PG: 'Papua New Guinea',
    PN: 'Pitcairn',
    SB: 'Solomon Islands',
    AS: 'American Samoa',
    WS: 'Samoa',
    SG: 'Singapore',
    TH: 'Thailand',
    TO: 'Tonga',
    TV: 'Tuvalu',
    VN: 'Viet Nam',
    VU: 'Vanuatu',
    WF: 'Wallis and Futuna',
    ZA: 'South Africa',
    AO: 'Angola',
    DZ: 'Algeria',
    BI: 'Burundi',
    BJ: 'Benin',
    BW: 'Botswana',
    CF: 'Central African Republic',
    CM: 'Cameroon',
    CG: 'Congo',
    KM: 'Comoros',
    CV: 'Cabo Verde',
    CI: "Côte d'Ivoire",
    DJ: 'Djibouti',
    EG: 'Egypt',
    ET: 'Ethiopia',
    ER: 'Eritrea',
    GA: 'Gabon',
    GH: 'Ghana',
    GM: 'Gambia',
    GW: 'Guinea-Bissau',
    GQ: 'Equatorial Guinea',
    GN: 'Guinea',
    BF: 'Burkina Faso',
    KE: 'Kenya',
    LR: 'Liberia',
    SS: 'South Sudan',
    LY: 'Libya',
    LS: 'Lesotho',
    MU: 'Mauritius',
    MG: 'Madagascar',
    ML: 'Mali',
    MZ: 'Mozambique',
    MR: 'Mauritania',
    MW: 'Malawi',
    NE: 'Niger',
    NG: 'Nigeria',
    NA: 'Namibia',
    RE: 'Réunion',
    RW: 'Rwanda',
    SD: 'Sudan',
    SN: 'Senegal',
    SC: 'Seychelles',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    SO: 'Somalia',
    SL: 'Sierra Leone',
    ST: 'Sao Tome and Principe',
    SZ: 'Eswatini',
    TD: 'Chad',
    TG: 'Togo',
    TN: 'Tunisia',
    TZ: 'Tanzania, United Republic of',
    UG: 'Uganda',
    CD: 'Congo',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    AR: 'Argentina',
    BR: 'Brazil',
    BO: 'Bolivia',
    CL: 'Chile',
    CO: 'Colombia',
    EC: 'Ecuador',
    FK: 'Falkland Islands',
    GF: 'French Guiana',
    GY: 'Guyana',
    PY: 'Paraguay',
    PE: 'Peru',
    SR: 'Suriname',
    UY: 'Uruguay',
    VE: 'Venezuela',
};

export const mmsiToFlag = (mmsi: number | string | null, width?: number): JSX.Element => {
    if (!mmsi) {
        return <></>;
    }
    if (typeof mmsi !== 'string') {
        mmsi = mmsi.toString();
    }
    const countryCode = countryCodesMapping[mmsi.substring(0, 3)];
    if (countryCode) {
        const widthOrDefault = width || 24;
        return <Flag countryCode={countryCode} width={widthOrDefault} height={widthOrDefault * 0.667} />;
    }
    return <></>;
};

export const mmsiToFullCountryName = (mmsi: number | string | null): string => {
    if (!mmsi) {
        return '';
    }
    if (typeof mmsi !== 'string') {
        mmsi = mmsi.toString();
    }
    const countryCode = countryCodesMapping[mmsi.substring(0, 3)];
    if (countryCode) {
        const countryName = countryCodeToFullName[countryCode];
        if (countryName) {
            return countryName;
        }
    }
    return 'Unknown';
};
